import { Integration_Handler_Names_Enum } from '@main/graphql/types.generated';
import { patternFilterSchema } from '@main/shared/utils';
import { z } from 'zod/v4';

import { IntegrationConfig } from '../../../../../../lib';
import { MdmService } from '../../service';

export type PatchPolicyConfig = typeof PatchPolicyConfig._.Config;

export const PatchPolicyConfig = IntegrationConfig.make({
  service: MdmService,
  name: Integration_Handler_Names_Enum.PatchPolicy,
  configSchema: z.object({
    systemPatternFilter: patternFilterSchema.optional(),
  }),
});
